export const ADD_WAREHOUSES = 'ADD_WAREHOUSES'
export const ADD_SCROLL_WAREHOUSES_DATA = 'ADD_SCROLL_WAREHOUSES_DATA'
export const ADD_NEXT_WAREHOUSES = 'ADD_NEXT_WAREHOUSES'
export const ADD_USERS_NOT_HAVE_WAREHOUSES = 'ADD_USERS_NOT_HAVE_WAREHOUSES'
export const LOAD_STORE_PRODUCTS = 'LOAD_STORE_PRODUCTS'